var Deferred = /** @class */ (function () {
    function Deferred(value) {
        var _this = this;
        this.value = value;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return Deferred;
}());
export { Deferred };
